var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9784 13.1636C23.6168 13.1636 26.5662 10.2169 26.5662 6.58182C26.5662 2.94678 23.6168 0 19.9784 0C16.3401 0 13.3906 2.94678 13.3906 6.58182C13.3906 10.2169 16.3401 13.1636 19.9784 13.1636Z",
    fill: "#023729"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9784 39.9996C23.6168 39.9996 26.5662 37.0528 26.5662 33.4178C26.5662 29.7827 23.6168 26.8359 19.9784 26.8359C16.3401 26.8359 13.3906 29.7827 13.3906 33.4178C13.3906 37.0528 16.3401 39.9996 19.9784 39.9996Z",
    fill: "#023729"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58781 26.5816C10.2262 26.5816 13.1756 23.6348 13.1756 19.9998C13.1756 16.3647 10.2262 13.418 6.58781 13.418C2.94946 13.418 0 16.3647 0 19.9998C0 23.6348 2.94946 26.5816 6.58781 26.5816Z",
    fill: "#023729"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4159 26.5816C37.0543 26.5816 40.0037 23.6348 40.0037 19.9998C40.0037 16.3647 37.0543 13.418 33.4159 13.418C29.7776 13.418 26.8281 16.3647 26.8281 19.9998C26.8281 23.6348 29.7776 26.5816 33.4159 26.5816Z",
    fill: "#023729"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9846 24.4728C22.4571 24.4728 24.4614 22.4703 24.4614 20.0001C24.4614 17.5299 22.4571 15.5273 19.9846 15.5273C17.5121 15.5273 15.5078 17.5299 15.5078 20.0001C15.5078 22.4703 17.5121 24.4728 19.9846 24.4728Z",
    fill: "#023729"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.17079efa0c3aa2f227c706ec7da4e5eb.svg";
export { ForwardRef as ReactComponent };